<template>
  <div>
    <page-title-area>
      <h1>{{ title }}</h1>
      <template #side-content>
        <entity-search-field
          v-if="searchHint"
          :value="query"
          :placeholder="searchHint"
          @input="value => $emit('update:query', value)"
        />
        <slot name="title-area-content" />
      </template>
      <template #right-floating-content>
        <counter :count="count" />
      </template>
    </page-title-area>
    <slot />
  </div>
</template>

<script>
import PageTitleArea from '@/components/atoms/PageTitleArea';
import Counter from '@/components/ContentHeader/Counter'; // TODO: Make Counter to atom
import EntitySearchField from '@/components/atoms/EntitySearchField';

export default {
  name: 'entity-list-layout',
  components: {
    Counter,
    EntitySearchField,
    PageTitleArea,
  },
  props: {
    title: String,
    count: Number,
    query: {
      type: String,
      required: false,
    },
    searchHint: {
      type: String,
      required: false,
    },
  },
};
</script>
